import React from "react";
import { useIntl, defineMessages } from "react-intl";
import { Button } from "@natera/form";
import "./billingPaymentFailure.scss";
import PaymentFailureIcon from "@app/preBill/assets/svg/payment-failure.svg";
import Svg from "@natera/material/lib/svg";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "@app/routing";
import BillingContactUs from "@app/postBill/components/billingContactUs";

const messages = defineMessages({
  billingPaymentFailureTitle: {
    id: "billingPaymentFailureTitle",
    defaultMessage:
      "Your payment couldn't be completed. Please check your information or try a different payment method.",
  },
  billingGoBackButton: {
    id: "billingGoBackButton",
    defaultMessage: "Go back",
  },
});

const BillingPaymentFailure: React.FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const { paymentPlanId, from } = location.state ?? {};

  const handleGoBackButton = () => {
    if (from === routes.billingUpdatePayment) {
      navigate(routes.billingPaymentPlanDetail, { state: { paymentPlanId } });
      return;
    }
    navigate(routes.billingPayment);
  };

  return (
    <div className="billing-payment-failure">
      <div className="billing-payment-failure__content">
        <div className="billing-payment-failure__icon">
          <Svg content={PaymentFailureIcon} />
        </div>
        <div className="billing-payment-failure__description">
          <div
            className="billing-payment-failure__title"
            data-testid="billingPaymentTitle"
          >
            {intl.formatMessage(messages.billingPaymentFailureTitle)}
          </div>
          <BillingContactUs />
        </div>
        <Button
          unelevated
          onClick={handleGoBackButton}
          className="billing-payment-failure__button"
        >
          {intl.formatMessage(messages.billingGoBackButton)}
        </Button>
      </div>
    </div>
  );
};

export default BillingPaymentFailure;
